import React from 'react';
import { Grid } from '@material-ui/core';

import Step from 'components/stepper/Step';
import Protected from 'components/Protected';

import EditRecipeBodyStep from './body/EditRecipeBodyStep';

import useEditRecipePage from './useEditRecipePage';

const EditRecipePageTitle = 'Recipe edition';

const EditRecipePage = () => {
  const {
    id,
    step,
    recipeEditPageRouter,
    goToMenuPage,
    exitPage,
    isAuthenticated,
  } = useEditRecipePage();

  return (
    <Grid container justify="center">
      <Grid item container xs={12} sm={10} md={8}>
        <Grid item container>
          {!isAuthenticated && (
            <Step
              stepTitle={EditRecipePageTitle}
              onBackButtonClick={exitPage}
              spacing={8}
              renderBody={() => {
                return <Protected></Protected>;
              }}
            ></Step>
          )}

          {isAuthenticated && (
            <EditRecipeBodyStep
              id={id}
              step={step}
              pageTitle={EditRecipePageTitle}
              router={recipeEditPageRouter}
              exitPage={exitPage}
              goToMenuPage={goToMenuPage}
            ></EditRecipeBodyStep>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditRecipePage;
